import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "iconfont icon-jiazaizhong"
};
const _hoisted_2 = {
  key: 1,
  class: "iconfont icon-complete"
};
const _hoisted_3 = {
  key: 2,
  class: "iconfont icon-fail_icon"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['process', `process-${$props.process}`])
  }, [$props.process === 'ready' || $props.process === 'uploading' ? (_openBlock(), _createElementBlock("span", _hoisted_1)) : $props.process === 'success' ? (_openBlock(), _createElementBlock("span", _hoisted_2)) : (_openBlock(), _createElementBlock("span", _hoisted_3))], 2);
}